const ContactMap = () => {
  return (
    <section className="w-full h-[60vh]">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3741.739276781337!2d85.88101467469568!3d20.31105621204291!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a190b000f7d36db%3A0xe81f8f2308297f48!2sUnique%20Syndicate%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1762586531081!5m2!1sen!2sin"
        width={"100%"}
        height="450"
      ></iframe>
    </section>
  );
};

export default ContactMap;
